export default function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <div className="section__divider"><span>Contact</span></div>
        <p className="contact__sub">
          I’m open to senior quality engineering roles, especially where automation, exploratory testing, and release ownership matter.
        </p>
        <p className="contact__sub">
          If that sounds useful for your team, get in touch.
        </p>
        <p className="contact__links">
          <a href="mailto:ch.monika28@gmail.com">ch.monika28@gmail.com</a>
          <span className="contact__dot">·</span>
          <a href="https://www.linkedin.com/in/chmonika28/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <span className="contact__dot">·</span>
          <a href="tel:+917291046761">+91 7291046761</a>
        </p>
      </div>
    </section>
  );
}
